<!-- <template>
    <div>
        <div class="with-flexible-parts mb-3rem">
            <span class="flexible-part learnworlds-icon learnworlds-overline-text fas fa-shopping-bag"></span>
            <div class="flexible-part">
                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                    Product name
                </div>
                <div class="learnworlds-main-text learnworlds-main-text-normal learnworlds-element">
                    The business of fashion and styling
                </div>
            </div>
        </div>

        <div class="with-flexible-parts mb-3rem">
            <span class="flexible-part learnworlds-icon learnworlds-overline-text fas fa-stamp"></span>
            <div class="flexible-part">
                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                    Product type
                </div>
                <div class="learnworlds-main-text learnworlds-main-text-normal learnworlds-element">
                    Course bundle
                </div>
            </div>
        </div>

        <div class="with-flexible-parts mb-3rem">
            <span class="flexible-part learnworlds-icon learnworlds-overline-text fas fa-book-open"></span>
            <div class="flexible-part">
                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                    Courses included
                </div>
                <div class="learnworlds-main-text learnworlds-main-text-normal learnworlds-element">
                    Course1, Course2, Course3
                </div>
            </div>
        </div>

        <div class="with-flexible-parts mb-3rem">
            <span class="flexible-part learnworlds-icon learnworlds-overline-text fas fa-tag"></span>
            <div class="flexible-part">
                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                    Price
                </div>
                <div class="learnworlds-main-text learnworlds-main-text-large learnworlds-element">
                    $55
                </div>
            </div>
        </div>

        <div class="with-flexible-parts mb-3rem">
            <span class="flexible-part learnworlds-icon learnworlds-overline-text fas fa-hand-holding-heart"></span>
            <div class="flexible-part" style="flex-grow: 1;">
                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                    Have a promo code?
                </div>
                <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp with-input-cols  align-items-stretch  no-gutter">
                    <div class="col no-padding span_10_of_12 span_10_of_12-tl span_10_of_12-tp span_10_of_12-sl span_10_of_12-sp flex-item">
                        <input type="text" class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal learnworlds-element" placeholder="Add your coupon code here">
                    </div>
                    <div class="col no-padding span_2_of_12 span_2_of_12-tl span_2_of_12-tp span_2_of_12-sl span_2_of_12-sp flex-item">
                        <button class="learnworlds-button learnworlds-element full-size learnworlds-button-solid-brand learnworlds-button-normal nowrap">
                            <span>Redeem</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>


        <div class="with-flexible-parts mb-3rem">
            <span class="flexible-part learnworlds-icon learnworlds-overline-text fas fa-receipt"></span>
            <div class="flexible-part fg-1">
                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                    Extra invoice info
                </div>
                <textarea class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal learnworlds-element" placeholder="Write some extra info for your invoice" style="height: 150px;"></textarea>
            </div>
        </div>


        <div class="with-flexible-parts mb-3rem">
            <span class="flexible-part learnworlds-icon learnworlds-overline-text fas fa-tags"></span>
            <div class="flexible-part">
                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                    Final Price
                </div>
                <div class="learnworlds-main-text lw-deleted-price learnworlds-element learnworlds-main-text-very-small inline-block no-margin-bottom">$55</div>
                <div class="learnworlds-main-text learnworlds-main-text-large learnworlds-element">
                    $35
                </div>
            </div>
        </div>

        <div class="learnworlds-button-wrapper lw-content-block learnworlds-element">
            <button class="js-same-content-child learnworlds-button learnworlds-button-large learnworlds-button-solid-accent1 learnworlds-element full-width">
                <span>Continue</span>
            </button>
        </div>

        <label class="checkbox-label with-flexible-parts" for="terms">
            <input class="checkbox flexible-part" type="checkbox" id="terms" name="terms" checked="">
            <div class="checkbox-box lw-border-color-fadeout80 flexible-part">
                <span class="learnworlds-icon learnworlds-heading3-small fas fa-check"></span>
            </div>
            <div class="flexible-part">
                <div class="learnworlds-main-text learnworlds-main-text-small learnworlds-element">
                    I agree with <a href="javascript:void(0)" target="_new">Privacy and terms</a>
                </div>
            </div>
        </label>
    </div>

</template>

<script>

    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "ProductCheckoutTemplate1",
        mixins: [ComponentTemplatesMixin],

    }
</script>

 -->



 <template>
    <div>
        <div>
            <div class="lw-cols main align-items-stretch one-row one-row-tl one-row-tp one-row-sl one-row-sp js-same-content-wrapper lw-dark-bg lw-padding-normal">
                <div class="col flex-item flexible span_4_of_12 vtop no-padding">
                    <div class="learnworlds-image no-margin-bottom learnworlds-bg-default stretched-bg learnworlds-framed-image learnworlds-element rectangle learnworlds-frame-size-full" style="background-image:url('http://api.learnworlds.develop/imagefile/https://learnworldsdev.blob.core.windows.net/dev-public/879ec193e285e98f8dbc1d57fe03b677.jpeg?client_id=5975dc817f6ef49c5d8b4567&amp;width=400&amp;height=0');">
                    </div>
                    <div class="lw-cols align-items-center lw-bundle-card-footer mt-2_5rem pt-2rem">
                        <div class="col no-padding flex-item span_9_of_12">
                            <p class="learnworlds-main-text learnworlds-element lw-text-color-fadeout50 learnworlds-main-text-small v-middle no-margin-bottom">Initial price</p>
                            <p data-node-type="text" class="learnworlds-main-text learnworlds-element learnworlds-main-text-normal">
                                <strong>Final price</strong>
                            </p>
                        </div>
                        <div class="col no-padding flex-item span_3_of_12">
                            <p class="learnworlds-main-text learnworlds-element lw-text-color-fadeout50 learnworlds-main-text-small lw-deleted-price v-middle no-margin-bottom">R$60</p>
                            <p data-node-type="text" class="learnworlds-main-text learnworlds-element learnworlds-main-text-normal">
                                <strong>R$10</strong>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col flex-item flexible with-flexible-parts span_8_of_12 vtop">
                    <div class="flexible-part js-lw-flexible-wrapper">
                        <div class="flexible-part">
                            <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                                Product Summary
                            </div>
                            <h4 class="learnworlds-heading4 learnworlds-element learnworlds-heading4-normal">
                                Course bundle (9 courses)
                            </h4>
                            <h3 class="learnworlds-heading3 learnworlds-element learnworlds-heading3-normal">
                                Piano Improvisation fundamentals
                            </h3>
                            <div class="learnworlds-main-text learnworlds-main-text-small learnworlds-element">
                                Piano fundamentals lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.
                            </div>
                            <button class="learnworlds-button learnworlds-element learnworlds-button-outline-light learnworlds-button-normal nowrap mt-3rem">
                                <span>See bundle’s full description</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="lw-padding-normal">

                <div class="flex-item no-padding flexible with-flexible-parts mb-3rem">
                    <div class="full-width">
                        <h3 class="learnworlds-heading3 learnworlds-element learnworlds-heading3-normal">
                            Register
                        </h3>
                        <div class="lw-cols">
                            <div class="col flex-item span_6_of_12 no-padding">
                                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                                    E-mail
                                </div>
                                <input type="text" class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal learnworlds-element" placeholder="E-mail">
                            </div>
                            <div class="col flex-item span_6_of_12 no-padding">
                                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                                    Password
                                </div>
                                <input type="text" class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal learnworlds-element">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex-item no-padding flexible with-flexible-parts mb-3rem">
                    <div class="full-width">
                        <h3 class="learnworlds-heading3 learnworlds-element learnworlds-heading3-normal">
                            Billing details
                        </h3>
                        <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                            Info to appear on your invoice
                        </div>
                        <textarea class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal learnworlds-element" placeholder="Write some extra info for your invoice" style="height: 150px;"></textarea>
                    </div>
                </div>

                <div class="flex-item no-padding flexible with-flexible-parts mb-3rem">
                    <div class="full-width">
                        <h3 class="learnworlds-heading3 learnworlds-element learnworlds-heading3-normal">
                            Payment Method
                        </h3>
                        <div class="lw-cols mb-2rem">
                            <div class="col flex-item span_6_of_12 no-padding">
                                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                                    Payment plan
                                </div>
                                <div class="select-wrapper">
                                    <select class="learnworlds-input learnworlds-input-normal learnworlds-input-solid-light no-margin-bottom">
                                        <option>12 payments of $9 per month</option>
                                        <option>Option 2</option>
                                        <option>Option 3</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col flex-item span_6_of_12 no-padding">
                                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                                    Your discount code (optional)
                                </div>
                                <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp with-input-cols align-items-stretch no-gutter">
                                    <div class="col no-padding span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp">
                                        <div class="col no-padding span_10_of_12 span_10_of_12-tl span_10_of_12-tp span_10_of_12-sl span_10_of_12-sp flex-item">
                                            <input type="text" class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal learnworlds-element" placeholder="Add your coupon code here">
                                        </div>
                                        <div class="col no-padding span_2_of_12 span_2_of_12-tl span_2_of_12-tp span_2_of_12-sl span_2_of_12-sp flex-item">
                                            <button class="learnworlds-button learnworlds-element full-size learnworlds-button-solid-brand learnworlds-button-normal nowrap">
                                                <span>Redeem</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="lw-cols">
                            <div class="col flex-item span_6_of_12 no-padding">
                                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                                    Card number
                                </div>
                                <input type="text" class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal learnworlds-element" placeholder="E-mail">
                            </div>
                            <div class="col flex-item span_3_of_12 no-padding">
                                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                                    Expiration date
                                </div>
                                <input type="text" class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal learnworlds-element" placeholder="MM/YY">
                            </div>
                            <div class="col flex-item span_3_of_12 no-padding">
                                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                                    CVV
                                </div>
                                <input type="text" class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal learnworlds-element" placeholder="CVV">
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            
        </div>

        <div class="with-flexible-parts justify-content-space-between align-items-center">
            <label class="checkbox-label with-flexible-parts" for="terms">
                <input class="checkbox flexible-part" type="checkbox" id="terms" name="terms" checked="">
                <div class="checkbox-box lw-brand-border flexible-part">
                    <span class="learnworlds-icon learnworlds-heading3-small fas fa-check"></span>
                </div>
                <div class="flexible-part">
                    <div class="learnworlds-main-text learnworlds-main-text-very-small learnworlds-element">
                        I agree with <a href="javascript:void(0)" target="_new">Privacy and terms</a>
                    </div>
                </div>
            </label>

            <div>
                <span>
                    <p class="learnworlds-main-text learnworlds-element learnworlds-main-text-normal nowrap">Total: &119</p>
                </span>

                <div class="learnworlds-button-wrapper lw-content-block learnworlds-element">
                    <button class="js-same-content-child learnworlds-button learnworlds-button-large learnworlds-button-solid-accent1 learnworlds-element">
                        <span>Confirm order</span>
                    </button>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "ProductCheckoutTemplate1",
        mixins: [ComponentTemplatesMixin],

    }
</script>

